/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Defaultlocation1Inputs */

const en__field_defaultlocation1 = /** @type {(inputs: _Field_Defaultlocation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default location`)
};

/**
* | output |
* | --- |
* | "Default location" |
*
* @param {_Field_Defaultlocation1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _field_defaultlocation1 = /** @type {((inputs?: _Field_Defaultlocation1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Defaultlocation1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_defaultlocation1(inputs)
});
export { _field_defaultlocation1 as "_field_defaultLocation" }